import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// Toolbar date label that opens a calendar — pick any day to jump the board/week there.
export function DateJump({ label, value, onPick, testId = "date-jump" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" title="Jump to a date" data-testid={testId}
          className="text-xs font-medium text-slate-700 min-w-[var(--datejump-minw,150px)] text-center num rounded-md px-2 py-1 hover:bg-slate-100 transition-colors">
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="center" data-testid={`${testId}-calendar`}>
        <Calendar mode="single" selected={value} defaultMonth={value} weekStartsOn={1}
          onSelect={(d) => { if (d) { onPick(d); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}

export default DateJump;
